import Category from 'src/models/item/Category'
import KitchenDisplay from 'src/models/kitchen-display/KitchenDisplay'
import Model, { encoders, ID, Integer, JsonObject, MODEL_LEVEL } from 'src/models/model'
import RegisterGrid from 'src/models/register/RegisterGrid'

export default class RegisterPage extends Model {
  static name = 'RegisterPage'

  static deletable = true

  static versioned = true

  static level = MODEL_LEVEL.SITE

  static employeeRequiredPermissionCategories = [Model.permissionCategories.HardwareAndRegisterStation]

  static define () {
    this.fields = {
      id: {
        type: ID,
        required: true
      },
      displayName: {
        type: String,
        required: true
      },
      displayOrder: {
        type: Integer,
        default: 100
      },
      type: {
        type: String,
        options: ['button-grid', 'ticket', 'activity-ticket', 'user-screen', 'library', 'showtimes', 'showing-schedule', 'categories', 'category', 'kitchen-display', 'specific-categorys'],
        default: 'button-grid'
      },
      iconName: {
        type: String,
        default: 'grid_on'
      },
      registerGrid: {
        type: RegisterGrid,
        encode: encoders.hasOne,
        reference: true
      },
      config: {
        type: JsonObject,
        mergeDefault: true,
        default () {
          return {
            screenIds: null,
            showTimeHeader: true,
            showTimeSlotHeader: false,
            showTimes: true,
            showTimeChips: true,
            showRating: true,
            showSeatChart: false,
            showPriceCard: true,
            showShowingBadges: true,
            showPosters: true,
            showProgressBar: true,
            highlightStartingShowings: true,
            highlightEndingShowings: true,
            highlightCurrentShowings: true,
            showRelativeTimes: true,
            showRelativeTimeChips: false,
            showCurrentTime: true,
            hideDistanceShowings: true,
            distantShowingThresholdHours: 3.5,
            zoom: 1.3,
            exlcudeItemCategories: false
          }
        }
      },
      category: {
        type: Category,
        encode: encoders.hasOne,
        reference: true
      },
      categories: {
        type: [Category],
        default: () => { return [] },
        encode (data) {
          data.categoryIds = _.map(this.categories.data, 'id')
        },
        reference: true,
        acceptsNestedAttributes: true
      },
      kitchenDisplay: {
        type: KitchenDisplay,
        default: null,
        encode: encoders.hasOne,
        reference: true
      }
    }
  }

  saveConfig (config) {
    this.config = config
    this.save()
  }

  shouldShowPage (order = null) {
    if (this.type === 'category') {
      return this.category.availableForShowings(order?.allShowings)
    }

    if (this.type === 'activity-ticket') {
      return this.context.currentUser?.superUser || false
    }

    return true
  }
}
